module.exports = __webpack_public_path__ + "static/media/stardew.e64dbd5f.png";